import React, { useState, useCallback, useEffect } from 'react';
import { injectIntl } from 'react-intl';

import { Modal } from 'sa-ui';

import messages from './SimulatedApproveModalMessages';

function SimulatedApproveModal(props) {
  const closeButton = {
    label: props.intl.formatMessage(messages.close),
    onClick: props.onClose,
  };
  const cancelButton = {
    label: props.intl.formatMessage(messages.cancel),
    onClick: props.onClose,
  };
  const continueButton = {
    label: props.intl.formatMessage(messages.continue),
    onClick: props.onContinue,
    primary: true,
  };

  function getSubtitle() {
    switch (true) {
      case props.status.success:
        return props.intl.formatMessage(messages.success);
      case props.status.error:
        return props.intl.formatMessage(messages.problem);
      default:
        return props.intl.formatMessage(messages.subtitle);
    }
  }

  function getButtons() {
    if (props.status.success || props.status.error) {
      return [closeButton];
    }
    return [cancelButton, continueButton];
  }

  return (
    <Modal
      {...props}
      icon="pe-7s-check-circle"
      title={props.intl.formatMessage(messages.title)}
      subtitle={getSubtitle()}
      buttons={getButtons()}
      small
    />
  );
}

export default injectIntl(SimulatedApproveModal);
